import { useSelector } from "react-redux";
import { userSelector } from "store/userSlice";
import ViewCategories from "pages/category/ViewCategories";
import AnnotatorDataset from "pages/datasets/AnnotatorDataset";

function Dashboard({
  datasets,
  setDatasets,
  pageCount,
  setPageCount,
  pageLimit,
  setPageLimit,
  totalAnnotationCount,
  setTotalAnnotationCount,
}: any) {
  const userInfo = useSelector(userSelector);

  return (
    <>
      {!userInfo?.permission_level && userInfo?.permission_level !== 0 ? (
        "" // Render nothing during loading (userInfo or permission_level is undefined/null)
      ) : userInfo.permission_level > 3 ? (
        <ViewCategories /> // Render for users with high permissions (> 3)
      ) : (
        <AnnotatorDataset // Render for users with permission_level <= 3 (including 0)
          datasets={datasets}
          setDatasets={setDatasets}
          pageCount={pageCount}
          setPageCount={setPageCount}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          totalAnnotationCount={totalAnnotationCount}
          setTotalAnnotationCount={setTotalAnnotationCount}
        />
      )}
    </>
  );
}

export default Dashboard;
